import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import * as actions from '../../../redux/user/actions.user';
import * as scriptEditorActions from '../../../redux/scriptEditor/actions.scriptEditor';
import withClickOutside from '../../../hoc/withClickOutside';
import ReactTooltip from 'react-tooltip';
import tooltipService from '../../../services/tooltipService';
import ConceptVideoToolWrapper from '../../components/ConceptVideoToolWrapper/ConceptVideoToolWrapper';
import BillingControlWrapper from '../../components/BillingControlWrapper/BillingControlWrapper';
import history from '../../../history';
import menuItems from '../../../const/menuItems';
import HeaderPartSeparator from '../HeaderPartSeparator/HeaderPartSeparator';
import getSupportEmailLink from '../../../services/mini/email/getSupportEmailLink';
import githubLogo from '../../../assets/images/billing/icon-github-small-black.svg';
import { connect } from 'react-redux';
import BalancePlate from '../BalancePlate/BalancePlate';
import device from '../../../services/mini/device';
import asyncDispatch from '../../../services/mini/asyncDispatch';
import UserInfoPopupSubMenu from './UserInfoPopupSubMenu';
import { fonts } from '../../../const/fonts';
import { codeThemes } from '../../../const/codeThemes';
import getUrlInfo from '../../../services/mini/getUrlInfo';
import { routeInfo } from '../../../routeInfo';


const isDesktop = device.isDesktop();

class UserInfoPopup extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showDocsTooltip: tooltipService.shouldShowDocsTooltip(),
            fontSizePopupOpened: false,
            themePopupOpened: false,
            isProfileReceived: false,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.manageTooltip();
        this.props.getUserBalance();
        this.props.getGithubLoginName().then(() => {
            if (!this._isMounted) return;
            this.setState({ isProfileReceived: true });
        }, () => {
            if (!this._isMounted) return;
            this.setState({ isProfileReceived: true });
        });
    }

    componentDidUpdate() {
        this.manageTooltip();
    }

    compoenntWillUnmount() {
        this._isMounted = false;
    }

    rememberDocsTooltip = () => {
        this.setState({ showDocsTooltip: false });

        tooltipService.saveDocsTooltipState();
    }

    manageTooltip() {
        let tooltip = ReactDOM.findDOMNode(this.refs.docsTooltip);
        let { showDocsTooltip } = this.state;
        if (device.isMobile()) return;
        if (showDocsTooltip) {
            setTimeout(() => {
                ReactTooltip.rebuild();
                ReactTooltip.show(tooltip);
            }, 300);
        } else {
            ReactTooltip.hide(tooltip);
        }
    }

    getMailToLink() {
        const { email, project } = this.props;
        return getSupportEmailLink(email, project);
    }

    toggleFontSizePopup = () => {
        this.setState({
            fontSizePopupOpened: !this.state.fontSizePopupOpened,
            themePopupOpened: false
        });
    }

    toggleThemePopup = () => {
        this.setState({
            themePopupOpened: !this.state.themePopupOpened,
            fontSizePopupOpened: false
        });
    }

    render() {
        const {
            memberOf,
            firstName,
            lastName,
            email,
            logOut,
            openedState,
            balance,
            freeInteractions,
            hideSettings,
            githubLogin,
            fontSize,
            theme,
            changeEditorFontSize,
            changeEditorTheme,
            createOrgAvailable,
            features
        } = this.props;

        const {
            fontSizePopupOpened,
            themePopupOpened,
            isProfileReceived,
            showDocsTooltip
        } = this.state;

        let name = '';
        const version = process.env.VERSION;

        if (firstName) {
            name += firstName;
        }

        if (lastName) {
            name += ' ' + lastName;
        }

        const { page } = getUrlInfo();

        return <div className={`user-info_panel ${openedState && 'opened'}`}>

            <div className="user-info_general">
                <span className="user-info_name">{name}</span>
                <span className="user-info_email">{email}</span>
                {memberOf && <span className="user-info_org">Organization: <span className="user-info_org-name">{memberOf}</span></span>}
                {isProfileReceived && githubLogin && <span className="user-info_github-account"><img src={githubLogo} /> {githubLogin}</span>}
                <div className="mobile-only">
                    <Link to={routeInfo.billing.path} style={{ textDecoration: 'none' }}><BalancePlate /></Link>
                </div>
            </div>

            <div className="user-info_sep" />

            {page === 'project' && <div
                className={`user-info_command ${fontSizePopupOpened && 'selected'}`}
                onClick={this.toggleFontSizePopup}>
                <i className="user-info_command_icon icon icon-alan-font-size" />
                Font Size
                <i className="user-info_command_sub-menu icon icon-arrow-right" />
                {fontSizePopupOpened &&
                    <UserInfoPopupSubMenu
                        items={fonts}
                        opened={fontSizePopupOpened}
                        onSelect={(val) => changeEditorFontSize({ fontSize: val })}
                        selectedItemId={fontSize} />}
            </div>}

            {page === 'project' && <div
                className={`user-info_command ${themePopupOpened && 'selected'}`}
                onClick={this.toggleThemePopup}>
                <div className="user-info_color-theme-icon">
                    <div><div /><div /></div>
                    <div><div /><div /></div>
                </div>
                Color Theme
                <i className="user-info_command_sub-menu icon icon-arrow-right" />
                {themePopupOpened &&
                    <UserInfoPopupSubMenu
                        items={codeThemes}
                        opened={themePopupOpened}
                        onSelect={(val) => changeEditorTheme({ codeTheme: val })}
                        selectedItemId={theme} />}
            </div>}

            <a target="_blank"
                rel="noreferrer"
                href={`${menuItems.docs.href}`}
                className="user-info_command">
                <div ref="docsTooltip"
                    data-place="left"
                    data-multiline="true"
                    data-effect="solid"
                    data-class="tutor-dark-tooltip docs-tooltip"
                    data-for="docsTooltip"
                    data-tip="123" />
                <i className="user-info_command_icon icon icon-alan-docs" />
                Docs
            </a>

            <a target="_blank"
                rel="noreferrer"
                href={this.getMailToLink()}
                className="user-info_command">
                <i className="user-info_command_icon icon icon-alan-support" />
                Ask Support
            </a>

            <ConceptVideoToolWrapper>
                <a rel="noreferrer"
                    href={'/tools/videoTool4.html'}
                    className="user-info_command">
                    <i className="user-info_command_icon icon icon-alan-visual-state" />
                    Concept Video Tool
                </a>
            </ConceptVideoToolWrapper>



            {(memberOf || createOrgAvailable) && <>
                {(!hideSettings && features?.organization?.enabled === true) &&
                    <Link to={routeInfo.organization.path} className={`user-info_command ${page === 'organization' ? 'selected' : ''}`}>
                        <div className="user-info_organisations-icon-holder">
                            <i className="user-info_command_icon icon icon-alan-user" />
                            <i className="user-info_command_icon icon icon-alan-user" />
                            <i className="user-info_command_icon icon icon-alan-user" />
                        </div>

                        Organization
                    </Link>}
            </>}


            {!hideSettings &&
                <BillingControlWrapper>
                    <Link to={routeInfo.plans.path} className={`user-info_command ${page === 'plans' ? 'selected' : ''}`}>
                        <i className="user-info_command_icon icon icon-alan-subscription" />
                        Subscription
                    </Link>
                </BillingControlWrapper>}

            {!hideSettings &&
                <Link to={routeInfo.profile.path} className={`user-info_command ${page === 'profile' ? 'selected' : ''}`}>
                    <i className="user-info_command_icon icon icon-alan-user" />
                    Profile
                </Link>}

            {(!hideSettings && features?.inviteFriends?.enabled === true) &&
                <Link to={routeInfo.inviteFriends.url()} className={`user-info_command ${page === 'invite-friends' ? 'selected' : ''}`}>
                    <i className="user-info_command_icon icon icon-invite-friend" />
                    Invite Friends
                </Link>}

            <BillingControlWrapper>
                <Link to={routeInfo.billing.path}
                    className={`user-info_command ${page === 'billing' ? 'selected' : ''}`}>
                    <i className="user-info_command_icon icon icon-balance" />
                    Billing
                    <div className="tablet-and-bigger">
                        <div className="user-info_panel_billing-holder">
                            <HeaderPartSeparator height={24} />
                            <BalancePlate />
                        </div>
                    </div>
                </Link>
            </BillingControlWrapper>

            {showDocsTooltip && <ReactTooltip id="docsTooltip">
                <div>If you want to know more<br /> about writing scripts in Alan <br />Studio, please visit <b>Docs</b>
                </div>
                <div className="alan-tooltip-got-it" onClick={this.rememberDocsTooltip}>Got It</div>
            </ReactTooltip>}
            <span className="user-info_command last"
                onClick={logOut}>
                <i className="user-info_command_icon icon icon-alan-log-out" />
                Log out
            </span>
        </div>;
    }
}


function mapStateToProps({ user, scriptEditor, config }) {
    return {
        email: user.email,
        tier: user.tier,
        memberOf: user.memberOf,
        githubLogin: user.githubLogin,
        firstName: user.firstName,
        lastName: user.lastName,
        hasProfileData: user.hasProfileData,
        balance: user.balance,
        freeInteractions: user.freeInteractions,
        hasPaymentInfo: user.hasPaymentInfo,
        createOrgAvailable: user.capabilities.createOrgAvailable,
        fontSize: scriptEditor.fontSize,
        theme: scriptEditor.codeTheme,
        features: config.features
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logOut: () => dispatch(actions.logOut()),
        getGithubLoginName: (param) => asyncDispatch(actions.getGithubLoginName, dispatch, param),
        getUserBalance: () => dispatch(actions.getUserBalance()),
        changeEditorFontSize: (param) => dispatch(scriptEditorActions.changeEditorFontSize(param)),
        changeEditorTheme: (param) => dispatch(scriptEditorActions.changeEditorTheme(param)),
    };
}

export default withClickOutside(connect(mapStateToProps, mapDispatchToProps)(UserInfoPopup));
